<template>
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex flex-column col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 container" :class="[`brand-${brandConfig.brand}`, `route-${$route.name}`]" :style="backgroundImage">
      <img v-if="showGgCrest" class="gg-crest" :src="brandLogo" alt="Goal Gambit" />
      <div class="router-view-container">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {setBrandConfig} from "./functions/setBrandConfig";

export default {
  computed: {
    ...mapState(['brandConfig']),
    isGoalGambit() {
      return this.brandConfig.brand === 'goal-gambit'
    },
    showGgCrest() {
      const ownLayout = ['MenuPage', 'CouponsPage', 'CouponValidityPage', 'TermsConditionsPage', 'HowToRedeemPage']
      return this.isGoalGambit && !ownLayout.includes(this.$route.name)
    },
    brandLogo() {
      return require(`@/brand/${this.brandConfig.brand}/brand-logo.png`)
    },
    headerImage() {
      if (!this.brandConfig.headerImage) return null

      try {
        return require(`@/brand/${this.brandConfig.brand}/header-image.png`)
      } catch (e) {
        return null
      }
    },
    backgroundImage() {
      if (this.headerImage) {
        return {
          backgroundColor: this.brandConfig.backgroundColor || '#fff',
          backgroundImage: `url(${this.headerImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          backgroundSize: '100% auto',
        }
      }
      return {
        backgroundImage: `url(${require(`@/brand/${this.brandConfig.brand}/background-image.png`)})`,
      }
    }
  },
  methods: {
    setFavicon() {
      
    },
  },
  beforeMount() {
    setBrandConfig();
    this.setFavicon();
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Unbounded:wght@400;600;700;900&display=swap');

@font-face {
  font-family: 'Poppins Regular';
  src: url('~@/assets/fonts/Poppins-Regular.ttf') format('truetype');
  font-weight: 100 900;
  font-style: normal;
}

.container {
  position: fixed;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  font-family: "Poppins Regular", sans-serif;
}

.router-view-container {
  position: relative;
  top: 34vh;
}

.brand-goal-gambit.container {
  justify-content: center;
}

.brand-goal-gambit .router-view-container {
  top: 0;
}

.container.brand-goal-gambit.route-SelectVoucher {
  justify-content: flex-start;
  padding-top: 14px;
}

.container.brand-goal-gambit.route-SelectVoucher .router-view-container {
  margin-top: 100px;
}

.gg-crest {
  width: 150px;
  height: auto;
  margin: 0 auto 14px;
  display: block;
  z-index: 2;
}

.brand-goal-gambit .header-text,
.brand-goal-gambit .bold-text {
  font-family: 'Unbounded', sans-serif;
}

.brand-goal-gambit .submit-btn,
.brand-goal-gambit .submit-btn-active,
.brand-goal-gambit .return-btn {
  background: linear-gradient(48deg, #FD9206 0%, #997A05 100%) !important;
  color: #1a1a1a !important;
}

.brand-goal-gambit .menu-btn-solid {
  background: linear-gradient(48deg, #FD9206 0%, #997A05 100%) !important;
  color: #1a1a1a !important;
  border-color: transparent !important;
}

.brand-goal-gambit .wallet-text,
.brand-goal-gambit .wallet-amount {
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 0 2px 3px rgba(0, 0, 0, 0.55);
}

/* Game2Win is the only white-background brand; the store's default white text
   (built for the dark brands) is invisible on it — force those spots black. */
.brand-game2win .bottom-disclaimer,
.brand-game2win .section-header,
.brand-game2win .wallet-amount,
.brand-game2win .main-heading,
.brand-game2win .description,
.brand-game2win .paragraph,
.brand-game2win .instruction-text,
.brand-game2win .menu-btn-solid {
  color: #000 !important;
}

.container.brand-mtn-checkmate-rush {
  background-position: center top;
}

.brand-mtn-checkmate-rush .router-view-container {
  top: 37vh;
}

.brand-mtn-checkmate-rush.route-SelectVoucher .menu-container {
  left: 20px;
}

.brand-mtn-checkmate-rush .wallet-text {
  color: #EA4E0F;
}

.container.brand-mtn-checkmate-rush .background-image {
  object-position: center top;
}

.container.brand-mtn-checkmate-rush .coupon-validity-container .background-image {
  height: 100%;
}

.brand-mtn-checkmate-rush .coupon-validity-container .content {
  top: 0;
  width: 88%;
  max-width: 430px;
  margin-top: 145px;
  padding: 18px 18px 4px;
  background: rgba(18, 18, 18, 0.88);
  border: 2px solid #EA4E0F;
  border-radius: 14px;
}

.brand-mtn-checkmate-rush .coupon-validity-container .main-heading {
  font-size: 17px;
  letter-spacing: 0.6px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(234, 78, 15, 0.55);
}

.brand-mtn-checkmate-rush .coupon-validity-container .paragraph {
  text-align: left;
  hyphens: manual;
  opacity: 1;
  color: rgba(255, 255, 255, 0.88);
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 14px;
}

.brand-mtn-checkmate-rush .terms-conditions-container .main-heading {
  margin-top: 142px;
}

.brand-mtn-checkmate-rush .terms-conditions-container .text-content {
  margin-top: 24px;
}

</style>
